import { ofType } from "redux-observable";
import { of } from "rxjs";
import { map, switchMap, mergeMap, catchError } from "rxjs/operators";
import { getJSON, postJSON, putJSON, deleteJSON } from "../utils/ajaxUtil";
import {
  REQUESTED_PRODUCT_BY_ID,
  REQUESTED_PRODUCT_BY_NAME,
  REQUESTED_PRODUCTS,
  REQUESTED_PRODUCT_PHASES,
  REQUESTED_PRODUCT_PHASES_BY_NAME,
  REQUESTED_CREATE_PRODUCT,
  REQUESTED_UPDATE_PRODUCT,
  REQUESTED_UPDATE_PRODUCT_VERSIONS,
  REQUESTED_UPDATE_PRODUCT_PHASES,
  REQUESTED_DELETE_PRODUCT,
  REQUESTED_CURRENT_PRODUCT_FAILED,
  receiveProducts,
  receiveProductById,
  receiveProductByName,
  receiveProductPhases,
  receiveProductPhasesByName,
  receiveCreateProduct,
  receiveUpdateProduct,
  receiveUpdateProductVersions,
  receiveUpdateProductPhases,
  receiveDeleteProduct,
} from "../redux/actions/productAction";

export const fetchProductsByUser = (action$) =>
  action$.pipe(
    ofType(REQUESTED_PRODUCTS),
    map((action) => action.payload.user),
    switchMap((user) =>
      getJSON(`/products`).pipe(map((res) => receiveProducts(res.data)))
    )
  );

export const fetchProductByName = (action$) =>
  action$.pipe(
    ofType(REQUESTED_PRODUCT_BY_NAME),
    map((action) => action.payload.name),
    switchMap((name) =>
      getJSON(`/products?name=${name}`).pipe(
        map((res) => receiveProductByName(res.data))
      )
    )
  );

export const fetchProductById = (action$) =>
  action$.pipe(
    ofType(REQUESTED_PRODUCT_BY_ID),
    map((action) => action.payload.id),
    switchMap((id) =>
      getJSON(`/products/${id}/`).pipe(
        map((res) => receiveProductById(res.data[0]))
      )
    )
  );

export const fetchProductPhase = (action$) =>
  action$.pipe(
    ofType(REQUESTED_PRODUCT_PHASES),
    map((action) =>
      Object.keys(action.payload.productsMap).map(
        (key) => action.payload.productsMap[key]
      )
    ),
    mergeMap((product) =>
      getJSON(`/products?name=${product.name}&phaseListOnly=1`).pipe(
        map((res) => receiveProductPhases(product.name, res.data))
      )
    )
  );

export const fetchProductPhaseByName = (action$) =>
  action$.pipe(
    ofType(REQUESTED_PRODUCT_PHASES_BY_NAME),
    map((action) => action.payload.name),
    mergeMap((name) =>
      getJSON(`/products?name=${name}&phaseListOnly=1`).pipe(
        map((res) => receiveProductPhasesByName(name, res.data))
      )
    )
  );

export const createProduct = (action$) =>
  action$.pipe(
    ofType(REQUESTED_CREATE_PRODUCT),
    map((action) => action.payload.product),
    switchMap((product) =>
      postJSON(`/products/`, product).pipe(
        map((res) => receiveCreateProduct(res.response.data)),
        catchError((error) =>
          of({
            type: REQUESTED_CURRENT_PRODUCT_FAILED,
            payload: error.xhr.response,
            error: true,
          })
        )
      )
    )
  );

export const updateProduct = (action$) =>
  action$.pipe(
    ofType(REQUESTED_UPDATE_PRODUCT),
    map((action) => action.payload.product),
    switchMap((product) =>
      putJSON(`/products/${product.id}/`, product).pipe(
        map((res) => receiveUpdateProduct(res.response.data[0]))
      )
    )
  );

export const updateProductVersions = (action$) =>
  action$.pipe(
    ofType(REQUESTED_UPDATE_PRODUCT_VERSIONS),
    map((action) => action.payload.product),
    switchMap((product) =>
      putJSON(`/products/${product.id}/versions`, product.versions).pipe(
        map((res) => receiveUpdateProductVersions(res.response.data[0]))
      )
    )
  );

export const updateProductPhases = (action$) =>
  action$.pipe(
    ofType(REQUESTED_UPDATE_PRODUCT_PHASES),
    map((action) => action.payload),
    switchMap((product) =>
      putJSON(`/products/${product.id}/phases`, product.phases).pipe(
        map((res) => receiveUpdateProductPhases(res.response.data[0]))
      )
    )
  );

export const deleteProduct = (action$) =>
  action$.pipe(
    ofType(REQUESTED_DELETE_PRODUCT),
    map((action) => action.payload.product),
    switchMap((product) =>
      deleteJSON(`/products/${product.id}/`).pipe(
        map((res) => receiveDeleteProduct(res))
      )
    )
  );
